<template>
  <div>
    <router-view />
    <van-tabbar v-if="show" :safe-area-inset-bottom="true" route active-color="#dc8208" inactive-color="#999999">
      <van-tabbar-item replace to="/index" icon="wap-home">首页</van-tabbar-item>
      <van-tabbar-item replace to="/introduce" icon="column">介绍</van-tabbar-item>
      <van-tabbar-item replace to="/mine" icon="manager">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      show: true,
      active: 0
    }
  },
  watch: {
    $route(val) {
      if (val.name == 'Index' || val.name == 'Introduce' || val.name == 'Mine') {
        this.show = true
      } else {
        this.show = false
      }
    }
  },
  methods: {
    onChange(index) {
      this.active = index
    }
  }
};
</script>